import ClassEdit from '@/controllers/class/class-edit.js';
import axios from "axios";
import store from '@/store';

export default {
  extends: ClassEdit,

  data() {
    return {
      teacherArr: [],
      homeroom_teacher_id: "",
      assistant_teacher_ids: [],
      selectedHomeroomTeacher: 0,
      selectedAssistantTeachers: [],
    };
  },

  mounted() {
    this.getAllTeacher();
  },

  methods: {
    getAllTeacher() {
      axios.get("/teacher/getallTeacher", {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then((response) => {
        this.teacherArr = response.data[0];
      }).catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },
  
    getClassEdit() {
      var request = {
        params: {
          campus_id: store.state.user.campus_id,
        },
      };
      axios
        .get("/class/detail/" + this.$route.params.id, request)
        .then((response) => {
          this.classData = response.data;
          this.selectedGrade = this.grade_id = this.classData.grade_id;
          this.academic_year = this.selectedYear = this.classData.academic_year;
          this.homeroom_teacher_id = this.selectedHomeroomTeacher =
            this.classData.homeroom_teacher_id || 0;
          this.assistant_teacher_ids = this.selectedAssistantTeachers =
            this.classData.assistant_teacher_ids || [];
          this.remark = this.classData.remark;
          this.getAcademicYearByGradeId(this.grade_id);
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.isLoading = false;
          console.log("Class Detail API Error", error);
        });
    },

    confirmUpdate() {
      if (this.disabled) return;
      this.submitted = true;
      if (
        this.classData.start_date &&
        this.classData.end_date &&
        new Date(this.classData.end_date) <= new Date(this.classData.start_date)
      ) {
        this.isError = true;
      } else {
        this.isError = false;
      }
      if (
        this.$v.$invalid ||
        this.grade_id == "" ||
        this.grade_id == 0 ||
        this.academic_year == "" ||
        this.academic_year == 0 ||
        this.section == "" ||
        this.section == 0 ||
        this.homeroom_teacher_id == 0 ||
        this.homeroom_teacher_id == "" ||
        this.isError
      ) {
        this.validationErrors = {};
        return;
      }

      this.clearValidationErrors();
      this.update();
    },

    update() {
      this.disabled = true;
      var request = {
        grade_id: this.grade_id,
        academic_year: this.academic_year,
        section: this.classData.section,
        remark: this.classData.remark,
        start_date: this.classData.start_date,
        end_date: this.classData.end_date,
        homeroom_teacher_id:
          this.homeroom_teacher_id == 0 ? null : this.homeroom_teacher_id,
        assistant_teacher_ids: this.assistant_teacher_ids || [],
        login_id: store.state.user.id,
        campus_id: store.state.user.campus_id,
      };
      axios
        .post("/class/update/" + this.$route.params.id, request, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status == 200) {
            this.$notification.success("Class Updated Successfully", {
              timer: 3,
              position: "bottomCenter",
            });
            this.$router.push({
              name: "classList",
            });
          } else if (response.status == 201) {
            this.isLoading = false;
            this.disabled = false;
            this.$notification.error("Class already exists.", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch((error) => {
          if (!this.showTeacherValidationNotifications(error.response)) {
            this.printValidationError(error.response);
          }
          
          if (error.response && error.response.status == 401) {
            this.$store.commit("logout");
            window.location.replace("login");
          }
          this.disabled = false;
          this.isLoading = false;
          console.log("Class Edit API Error", error.errors);
        });
    },

    showTeacherValidationNotifications(response) {
      if (!response || response.status !== 422 || !response.data.errors) {
        return false;
      }

      const teacherErrorFields = ["homeroom_teacher_id", "assistant_teacher_ids"];
      let hasNotificationError = false;

      teacherErrorFields.forEach((field) => {
        if (response.data.errors[field]) {
          this.$notification.error(response.data.errors[field][0], {
            timer: 3,
            position: "bottomCenter",
          });
          hasNotificationError = true;
        }
      });

      return hasNotificationError;
    },
  },
};
